// 通过这个对象，实现模块化开发。宿主程序views/modules目录必须存在。
// modules目录下的每个目录，都是一个模块（插件）
// modules目录下的每个目录下，如果需要路由或者api，则添加module.apis.js和module.routers.js。这两个文件分别是针对当前模块(插件)定义的“api”和“路由”
// 模块所属的“路由”和“api”，在声明的时候，要根据当前插件的名字，设置唯一的路由名和api名称
// modules目录下的base.apis.js和base.router.js是基础的api定义和路由定义。不用修改
const loadApisAndRouters = {
  loadApis: () => {
    const apis = {}
    // 递归获取 views/modules 文件夹下的所有.api.js文件
    const apiFiles = require.context('@/views/modules', true, /\.apis.js$/)
    apiFiles.keys().forEach(key => {
      Object.assign(apis, apiFiles(key).default)
    })
    return apis
  },
  loadRouters: () => {
    let routers = []
    // 递归获取 views/modules 文件夹下的所有.router.js文件
    const routerFiles = require.context('@/views/modules', true, /\.routers.js$/)
    routerFiles.keys().forEach(key => {
      routers = routers.concat(routerFiles(key).default)
    })
    return routers
  }
}

export default loadApisAndRouters
